import React, { useState } from 'react';

import { Button, Modal, Text } from '@shared/components/bootstrap';
import { Currency } from '@shared/components/helpers';

import { IInvoiceActionProps, IInvoiceActionFormProps } from '@admin/components/billing/invoices/types';
import { Permission } from '@admin/components/helpers/permission';
import { BILLING } from '@admin/libraries/access_control_catalog.generated';

import { InvoiceMarkAsPaidForm } from './mark_as_paid/form';

const MarkAsPaidModal: React.FC<IInvoiceActionFormProps> = (props) => (
  <Modal centered onClose={props.onCancel}>
    <Modal.Content>
      <Modal.Header>
        <Modal.Title>Make Other Payment On Invoice #{props.invoiceID}</Modal.Title>
        <Text tag="p">
          Amount Due: <Currency value={props.amountOwed} />
        </Text>
        <Modal.Close close={props.onCancel} />
      </Modal.Header>
      <Modal.Body>
        <InvoiceMarkAsPaidForm {...props} />
      </Modal.Body>
    </Modal.Content>
  </Modal>
);

export const MarkAsPaid: React.FC<IInvoiceActionProps> = ({ invoiceID, accountID, amountOwed, onSave }) => {
  const [showModal, setShowModal] = useState<boolean>(false);

  return (
    <Permission resource={BILLING.resource} action={BILLING.actions.update} denied={null}>
      <Button kind="danger" onClick={() => setShowModal(true)}>
        Other Payment
      </Button>
      {showModal && (
        <MarkAsPaidModal
          onCancel={() => setShowModal(false)}
          onSave={(attemptID) => {
            setShowModal(false);
            onSave(attemptID, 'Invoice successfully paid offline');
          }}
          invoiceID={String(invoiceID)}
          accountID={String(accountID)}
          amountOwed={Number(amountOwed)}
        />
      )}
    </Permission>
  );
};
